import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import socialmediaimage from '../assets/socialmedia.png';
import '../style/signup.css'; // reuse existing styles or create a new one

const completesetup = () => {
return (
<section className='signup'>
    <Container>
    <Row className="align-items-center">
        {/* Form Section */}
        <Col lg={7} className="form-section p-4">
        <h2>
            Complete <em className='fw-semibold'>Setup</em> 
        </h2>
        {/* <p>A listing can always be updated later.</p> */}

        <Form className="mt-4 biodiscrition">
            <Form.Group className="mb-3">
        <Form.Label>Bio/Description</Form.Label>
        <textarea
id="bio"
name="bio"
className="bio-textarea"
placeholder="Enter information about your farm"
rows="5"
/>
        </Form.Group>

            <Form.Group className="mb-3 onlyletters">
            <Form.Label>Custom URL</Form.Label>
            <Form.Control type="text" />
            <p>Only letters, numbers, dash and underscore are allowd</p>
            </Form.Group>

            {/* extendeddetails */}
            <div className='extendeddetails'>
                <h4>Address Information</h4>
            <p>Full adress details help provide the best experience. Lorem Full ispum details help provide the best experience Lorem Full adress details help provide the best experience</p>
            </div>

            <Form.Group className="mb-3">
            <Form.Label>Extended Address</Form.Label>
            <Form.Control type="Email" placeholder='Enter your email'/>
            </Form.Group>


            <Form.Group className="mb-3">
            <Form.Label>Street Address</Form.Label>
            <Form.Control type="text" />
            </Form.Group>

            <Row className="mb-3">
            <Col>
            <Form.Label>City</Form.Label>
                <Form.Control type="text" placeholder="City" />
            </Col>
            <Col>
            <Form.Label>State</Form.Label>
                <Form.Control type="text" placeholder="State" />
            </Col>
            <Col>
            <Form.Label>Zip Required</Form.Label>
                <Form.Control type="text" placeholder="Zip Required" />
            </Col>
            </Row>

            <Button href='/Firstlisting' type="submit" className="w-100 mt-3 btn btn-submit">
            Next Step
            </Button>
        </Form>
        </Col>

        {/* Image Section */}
        <Col lg={5} className="image-section text-center">
        <img
            src={socialmediaimage}
            alt="Farmers Market"
            className="img-fluid rounded shadow"
        />
        </Col>
    </Row>
    </Container>
</section>
);
};

export default completesetup;
